import React from 'react';

export default () => {
    return (
        <>
            <p>Here is GenerateInterface.Home</p>
        </>
    )
}